import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBoardInit.query';

export const getCardImportance = (params: QueryParams) => {
    const url = `api/bo/boardinit/getCardImportance?metaDataId=${params.metaDataId}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
